import { createAction, createSlice } from "@reduxjs/toolkit";
import { getProdTheme, getTheme } from "../models/theme";
import { DEFAULT_THEME_CONFIG } from "../constants/defaultTheme";
import { AppThunk } from "../store";
import { isProd } from "../constants/system";

const initialTheme = isProd ? getProdTheme() : DEFAULT_THEME_CONFIG;

const initialState = {
  isThemeLoaded: false,
  theme: initialTheme,
};

export const resetThemeState = createAction("theme/resetState");

export const themeSlice = createSlice({
  name: "theme",
  initialState: initialState,
  reducers: {
    fetchTheme: (state, action) => {
      state.theme = action.payload.theme;
      state.isThemeLoaded = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetThemeState, () => initialState);
  },
});

export const { fetchTheme: fetchThemeAction } = themeSlice.actions;

export const fetchTheme = (): AppThunk => async (dispatch) => {
  // Theme is already loaded on prod
  if (isProd) return;
  try {
    const theme = await getTheme();
    dispatch(fetchThemeAction({ theme }));
  } catch (e) {
    console.log("Fail to fetch theme: ", e);
  }
};

export default themeSlice.reducer;
